// @ts-check

import { api } from '@/api'
import { useMemoize } from '@vueuse/core'

/**
 * @param {AttachmentPayload} payload
 * @returns {Promise<AttachmentResource>}
 */
export const createAttachment = async (payload) => {
  const { data: attachment } = await api.post('attachments', payload)
  return attachment
}

/**
 * @param {AttachmentResource['id']} attachmentId
 * @param {AttachmentAttachPayload} payload
 * @returns {Promise<void>}
 */
export const attachAttachment = async (attachmentId, payload) => {
  await api.post(`attachments/${attachmentId}/attach`, payload)
}

/**
 * @type {import('@vueuse/core').UseMemoizeReturn<Promise<AttachmentResource>, [AttachmentResource['id']]>}}
 */
export const getAttachment = useMemoize(async (attachmentId) => {
  const res = await api.get(`attachments/${attachmentId}`)
  return res.data
})

/**
 * @param {AttachmentQueryParams} params
 * @returns {Promise<Attachments>}
 */
export const getAttachments = async (params = {}) => {
  const res = await api.get('attachments', { params })
  return res.data
}

/**
 * @param {AttachmentResource['id'][]} attachmentIds
 * @returns {Promise<AttachmentResource[]>}
 */
export const getAttachmentsByIds = async (attachmentIds) =>
  Promise.all(attachmentIds.map(getAttachment))

/**
 * @param {AttachmentResource['id']} attachmentId
 * @returns {Promise<unknown>}
 */
export const previewAttachment = async (attachmentId) =>
  api.get(`attachments/${attachmentId}/preview`)

/**
 * @param {AttachmentResource['id']} attachmentId
 * @returns {Promise<void>}
 */
export const deleteAttachment = async (attachmentId) =>
  api.delete(`attachments/${attachmentId}`)
